export default "__VITE_ASSET__BAFmhNla__"